import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, addDoc, serverTimestamp } from 'firebase/firestore';

const ExpensePage = () => {
    const [masraflar, setMasraflar] = useState([]);
    const [projeler, setProjeler] = useState([]);
    const [personeller, setPersoneller] = useState([]);
    const [yeniMasraf, setYeniMasraf] = useState({ 
        baslik: "", miktar: "", kategori: "Genel", proje: "", 
        personelId: "", yevmiyeAdet: 1, birimUcret: 0 
    });

    useEffect(() => {
        onSnapshot(collection(db, "projeler"), (snap) => setProjeler(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
        onSnapshot(collection(db, "masraflar"), (snap) => setMasraflar(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
        onSnapshot(collection(db, "personel"), (snap) => setPersoneller(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    }, []);

    // Personel seçildiğinde günlük ücretini otomatik getir
    const personelSec = (id) => {
        const p = personeller.find(x => x.id === id);
        if (p) {
            setYeniMasraf({
                ...yeniMasraf, 
                personelId: id, 
                baslik: `${p.adSoyad} - Yevmiye Ödemesi`,
                birimUcret: p.gunlukUcret || 0,
                miktar: (p.gunlukUcret || 0) * yeniMasraf.yevmiyeAdet
            });
        }
    };

    const masrafKaydet = async () => {
        if (!yeniMasraf.miktar || !yeniMasraf.proje) return alert("Eksik alanları doldurun!");
        await addDoc(collection(db, "masraflar"), {
            ...yeniMasraf,
            miktar: parseFloat(yeniMasraf.miktar),
            tarih: serverTimestamp()
        });
        alert("Kayıt Başarılı!");
        setYeniMasraf({ baslik: "", miktar: "", kategori: "Genel", proje: "", personelId: "", yevmiyeAdet: 1 });
    };

    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 text-white font-sans">
            
            {/* GİRİŞ FORMU */}
            <div className="bg-slate-900 p-8 rounded-[2.5rem] border border-slate-800 shadow-2xl">
                <h2 className="text-xl font-black text-blue-500 mb-6 uppercase italic">Gider/Yevmiye İşle</h2>
                
                <div className="flex flex-col gap-4">
                    {/* KATEGORİ SEÇİMİ */}
                    <div>
                        <label className="text-[10px] font-black text-slate-500 ml-2 uppercase">Gider Türü</label>
                        <select 
                            value={yeniMasraf.kategori}
                            onChange={(e) => setYeniMasraf({...yeniMasraf, kategori: e.target.value})}
                            className="w-full bg-slate-950 border border-slate-800 p-4 rounded-2xl outline-none focus:border-blue-500 font-bold"
                        >
                            <option value="Genel">📝 Genel Gider</option>
                            <option value="Personel">👥 Personel & Yevmiye</option>
                            <option value="Enerji">⚡ Mazot / Enerji</option>
                        </select>
                    </div>

                    {/* EĞER PERSONEL SEÇİLİYSE DETAYLAR AÇILIR */}
                    {yeniMasraf.kategori === "Personel" && (
                        <div className="bg-blue-500/5 p-4 rounded-2xl border border-blue-500/20 flex flex-col gap-3">
                            <select 
                                onChange={(e) => personelSec(e.target.value)}
                                className="w-full bg-slate-950 border border-slate-800 p-3 rounded-xl text-sm font-bold"
                            >
                                <option value="">İşçi Seçiniz...</option>
                                {personeller.map(p => <option key={p.id} value={p.id}>{p.adSoyad} ({p.gunlukUcret}₺)</option>)}
                            </select>
                            
                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <label className="text-[9px] font-black text-slate-500 ml-2">YEVMIYE ADET</label>
                                    <input 
                                        type="number" 
                                        value={yeniMasraf.yevmiyeAdet}
                                        onChange={(e) => setYeniMasraf({...yeniMasraf, yevmiyeAdet: e.target.value, miktar: e.target.value * yeniMasraf.birimUcret})}
                                        className="w-full bg-slate-950 border border-slate-800 p-3 rounded-xl text-center font-black"
                                    />
                                </div>
                                <div className="flex flex-col justify-end">
                                    <span className="text-[10px] text-slate-500 font-bold">TOPLAM ÖDEME</span>
                                    <span className="text-xl font-black text-emerald-500">₺{yeniMasraf.miktar}</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* PROJE SEÇİMİ */}
                    <div>
                        <label className="text-[10px] font-black text-slate-500 ml-2 uppercase">İlgili Proje</label>
                        <select 
                            value={yeniMasraf.proje}
                            onChange={(e) => setYeniMasraf({...yeniMasraf, proje: e.target.value})}
                            className="w-full bg-slate-950 border border-blue-900/30 p-4 rounded-2xl outline-none focus:border-blue-500 font-bold text-blue-400"
                        >
                            <option value="">Proje Seç...</option>
                            {projeler.map(p => <option key={p.id} value={p.ad}>{p.ad}</option>)}
                        </select>
                    </div>

                    {yeniMasraf.kategori !== "Personel" && (
                        <input 
                            placeholder="Açıklama (Örn: Traktör Tamiri)" 
                            className="bg-slate-950 border border-slate-800 p-4 rounded-2xl outline-none"
                            value={yeniMasraf.baslik}
                            onChange={(e) => setYeniMasraf({...yeniMasraf, baslik: e.target.value})}
                        />
                    )}

                    {yeniMasraf.kategori !== "Personel" && (
                        <input 
                            type="number"
                            placeholder="Miktar ₺" 
                            className="bg-slate-950 border border-slate-800 p-4 rounded-2xl outline-none font-black text-emerald-500 text-xl"
                            value={yeniMasraf.miktar}
                            onChange={(e) => setYeniMasraf({...yeniMasraf, miktar: e.target.value})}
                        />
                    )}

                    <button 
                        onClick={masrafKaydet}
                        className="bg-blue-600 hover:bg-blue-500 p-5 rounded-2xl font-black text-xs uppercase transition-all shadow-xl shadow-blue-900/30"
                    >
                        Harcamayı/Yevmiyeyi İşle
                    </button>
                </div>
            </div>

            {/* LİSTELEME ALANI */}
            <div className="lg:col-span-2 bg-slate-900 p-8 rounded-[2.5rem] border border-slate-800 shadow-2xl overflow-hidden flex flex-col h-[75vh]">
                <h2 className="text-xl font-black text-slate-400 mb-6 uppercase italic">İşlem Geçmişi</h2>
                <div className="overflow-y-auto pr-2 custom-scrollbar flex-1">
                    {masraflar.map(m => (
                        <div key={m.id} className="bg-slate-950 border border-slate-800 p-5 rounded-3xl mb-3 flex justify-between items-center hover:border-slate-600 transition-all">
                            <div className="flex flex-col gap-1">
                                <span className="font-black text-sm uppercase tracking-tighter">{m.baslik}</span>
                                <div className="flex gap-2">
                                    <span className="text-[9px] bg-slate-800 px-2 py-0.5 rounded-lg text-slate-400 font-bold uppercase">{m.kategori}</span>
                                    <span className="text-[9px] bg-blue-500/10 px-2 py-0.5 rounded-lg text-blue-500 font-black uppercase">{m.proje}</span>
                                    {m.yevmiyeAdet && <span className="text-[9px] text-orange-500 font-bold">{m.yevmiyeAdet} Yevmiye</span>}
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="font-black text-xl text-red-500">- ₺{m.miktar}</p>
                                <p className="text-[8px] text-slate-600 font-bold uppercase">{m.tarih?.toDate().toLocaleDateString('tr-TR')}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ExpensePage;